import {useQuery} from "@tanstack/react-query";
import {getDevicesService} from "../../user/saga/auth/get-devices";

export const IUseGetDevices = 'IUseGetDevices';

export function useQueryGetDevices () {
  return useQuery([IUseGetDevices], getDevicesService);
}
